import moment from "moment";
import React, { useRef, useState } from "react";
import { Overlay } from "react-bootstrap";
import userAvatar from "../../../Images/Images/avatar.png";
import { useTranslation } from "react-i18next";
import MediaPreview from "../MediaPreview";
import { IMAGE_END_POINT } from "../../../Api/EndPoints";

const commentTabs = {
  RESELLER: {
    client: "Comments",
  },
  INVOICE: {
    client: "Comments",
  },
  PROSPECT: {
    client: "Comments",
  },
  EXPENSE: {
    client: "Comments",
  },
  ORDER: {
    client: "Comments",
  },
  SAV: {
    client: "Exchanges",
    admin: "Notes",
  },
  APPROV: {
    client: "Comment",
  },
};

function FavoriteComment({
  view,
  message,
  isOwner,
  setActiveTab,
  setScrollableComment,
}) {
  const { t } = useTranslation("common");
  const ref = useRef();
  const target = useRef(null);
  const [previewMedia, setPreviewMedia] = useState();
  const [showOverlay, setShowOverlay] = useState();
  const commentRef = useRef(null);

  const date = moment(message?.createdAt).format("HH:mm");

  const user = message?.user;
  const photoUrl = user?.photo?.url;

  let title = "";
  if (user?.userRole === 1) {
    title = t("Administrator");
  } else if (user?.userRole === 0) {
    title = user?.profil?.reseller?.name ?? "";
  } else if (user?.userRole === 2) {
    title = user?.business_affiliate?.name;
  }

  const fullName = [user?.firstName, user?.lastName].join(" ").trim();
  const attachments = message?.attachments;

  return (
    <div
      className={`messageContainer d-flex mt-3 mb-2 ${
        isOwner ? "ms-auto flex-row-reverse" : "me-auto"
      }`}
      ref={ref}
    >
      <img
        ref={target}
        src={photoUrl ? `${IMAGE_END_POINT}${photoUrl}` : userAvatar}
        alt={fullName}
        className={`message-user mt-auto mb-4 ${isOwner ? "ms-3" : "me-3"}`}
        onMouseOver={() => setShowOverlay(true)}
        onMouseOut={() => setShowOverlay(false)}
      />
      <Overlay
        target={target.current}
        show={showOverlay}
        placement="bottom-start"
      >
        {(props) => (
          <div
            {...props}
            style={{
              ...props.style,
              zIndex: 99999,
              boxShadow: "0px 3px 6px #0000001a",
            }}
            className="d-flex align-items-center p-12px bg-white br5"
          >
            <img
              src={photoUrl ? `${IMAGE_END_POINT}${photoUrl}` : userAvatar}
              alt=""
              width={34}
              height={34}
              className="ob-cover rounded-circle"
            />
            <div className="d-flex flex-column ms-2 ps-1">
              {fullName && (
                <p className="f14 mb-0 semi-bold text-dark">{fullName}</p>
              )}
              <p className="f14 mb-0 text-brightGrey">{title}</p>
            </div>
          </div>
        )}
      </Overlay>
      <div className="w-100">
        <div
          className={`position-relative d-flex w-100 flex-column br5 ${
            isOwner ? "ms-auto bg-blue-100" : "bg-gray-200"
          }`}
          ref={commentRef}
        >
          <div
            className={`f14 text-blue-900 medium d-flex justify-content-between pe-1`}
          >
            {message?.text?.length > 0 && (
              <div
                className="py-2 px-3 wordBreak"
                dangerouslySetInnerHTML={{ __html: message?.text }}
              />
            )}
          </div>

          {attachments?.length > 0 && (
            <div
              className={`d-flex p-3 flex-wrap gap-2 ${
                isOwner ? "justify-content-end" : "justify-content-start"
              }`}
            >
              {attachments.map((attach) => {
                const file = attach?.file;
                const url = file?.url;
                const fileName = file?.name;
                const fileType = file?.mime;
                const isImage = fileType?.includes("image");
                const isVideo = fileType?.includes("video");

                return (
                  <div
                    key={attach?.id}
                    className="d-flex align-items-center justify-content-center position-relative parent-hover"
                  >
                    <button
                      className={`outline-none border-0 br5 overflow-hidden w-100px h-100px d-flex align-items-center justify-content-center ${
                        isOwner ? "ms-auto bg-blue-100" : "bg-gray-200"
                      }`}
                      onClick={() =>
                        (isImage || isVideo) && setPreviewMedia(file)
                      }
                    >
                      {isImage ? (
                        <img
                          src={IMAGE_END_POINT + url}
                          alt={fileName}
                          className="ob-cover br5"
                          width={100}
                          height={100}
                        />
                      ) : isVideo ? (
                        <video width={100} height={100}>
                          <source src={IMAGE_END_POINT + url} type={fileType} />
                        </video>
                      ) : (
                        <a
                          href={`${IMAGE_END_POINT}${url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-flex align-items-center justify-content-center mb-0 text-blue f14 h-100 w-100 bg-white"
                        >
                          {t("Document")}
                        </a>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center px-3 pb-2 pt-0">
            <p className="mb-0 sBold f11 text-darkGrey">{date}</p>
            <button
              className="bg-transparent border-0 bold text-darkBlue f12"
              onClick={() => {
                const nextTab = [
                  "ORDER",
                  "APPRO",
                  "EXPENSE",
                  "PROSPECT",
                  "INVOICE",
                  "RESELLER",
                ]?.includes(view)
                  ? commentTabs[view].client
                  : message.onlyAdmin
                  ? commentTabs[view].admin
                  : commentTabs[view].client;
                setActiveTab(nextTab);
                setScrollableComment(message.id);
              }}
            >
              {t("See the message")}
            </button>
          </div>
        </div>
      </div>
      {previewMedia && (
        <MediaPreview
          file={previewMedia?.url}
          setPreviewMedia={setPreviewMedia}
          mediaType={
            previewMedia?.mime?.includes("image")
              ? "image"
              : previewMedia?.mime?.includes("video")
              ? "video"
              : null
          }
          isUrl
        />
      )}
    </div>
  );
}

export default FavoriteComment;
